import _                                  from 'underscore';
import React, { FC }                      from 'react';
import styled                             from 'styled-components';
import { CorvalUIColor, SemanticUIColor } from '../../../../types';
import { getCSSVar }                      from '../../../../util/BrowserUtility';

export interface HexagonShapeProps {
	size?: number,
	rotation?: number,
	customColor?: string,
	color?:
		string
		| SemanticUIColor
		| CorvalUIColor.WHITE
		| CorvalUIColor.GRAY
		| CorvalUIColor.OBSIDIAN
		| CorvalUIColor.ONYX
		| CorvalUIColor.LIGHTBLACK
		| CorvalUIColor.LIGHTBLUE
		| CorvalUIColor.LIGHTGREEN
		| CorvalUIColor.LIGHTORANGE
		| CorvalUIColor.LIGHTPINK
		| CorvalUIColor.LIGHTOLIVE
		| CorvalUIColor.LIGHTPURPLE
		| CorvalUIColor.LIGHTRED
		| CorvalUIColor.LIGHTTEAL
		| CorvalUIColor.LIGHTYELLOW
		| CorvalUIColor.BLUEBACKGROUND
		| CorvalUIColor.GREENBACKGROUND
		| CorvalUIColor.ORANGEBACKGROUND
		| CorvalUIColor.PINKBACKGROUND
		| CorvalUIColor.OLIVEBACKGROUND
		| CorvalUIColor.PURPLEBACKGROUND
		| CorvalUIColor.REDBACKGROUND
		| CorvalUIColor.TEALBACKGROUND
		| CorvalUIColor.YELLOWBACKGROUND
		| CorvalUIColor.DARKBLUE
		| CorvalUIColor.DARKGREEN
		| CorvalUIColor.DARKORANGE
		| CorvalUIColor.DARKPINK
		| CorvalUIColor.DARKOLIVE
		| CorvalUIColor.DARKPURPLE
		| CorvalUIColor.DARKRED
		| CorvalUIColor.DARKTEAL
		| CorvalUIColor.DARKYELLOW
		| CorvalUIColor.OFFWHITE
		| CorvalUIColor.DARKWHITE
		| CorvalUIColor.LIGHTGREY,

	[ additionalProps: string ]: any
}

const defaultProps: HexagonShapeProps = {
	size:        100,
	color:       SemanticUIColor.TEAL,
	customColor: null,
	rotation:    0,
}

const hexDimensionsFactor = 0.57736;

const Hexagon = styled.div<HexagonShapeProps>`
	position: relative;
    width: ${ props => props.size }px;
    height: ${ props => props.size * hexDimensionsFactor }px;
    background: ${ props => props.color };
    margin: ${ props => ( ( props.size * hexDimensionsFactor ) / 2 ) }px auto;
    transform: translateZ(1px) rotate( ${ props => props.rotation }deg );
    
    &:before, &:after {
	  content: "";
	  position: absolute;
	  border-left: ${ props => props.size / 2 }px solid transparent;
	  border-right: ${ props => props.size / 2 }px solid transparent;
	}
	
	&:before {
	  bottom: 100%;
	  border-bottom: ${ props => ( ( props.size * hexDimensionsFactor ) / 2 ) }px solid ${ props => props.color };
	}
	
	&:after {
	  top: 100%;
	  border-top: ${ props => ( ( props.size * hexDimensionsFactor ) / 2 ) }px solid ${ props => props.color };
	}
`;

const HexagonShape: FC<HexagonShapeProps> = ( props ) => {

	let color    = props.customColor ?? getCSSVar( `--color-${ props.color }`, props.color ),
	    rotation = _.isNumber( props.rotation ) ? props.rotation : 0,
	    size     = props.size;

	return <Hexagon size={ size } color={ color } rotation={ rotation }>{ props.children }</Hexagon>;
};

HexagonShape.defaultProps = defaultProps;

export { HexagonShape }
